'use client';
import React from 'react';
import styled from 'styled-components';
import { useModalContext } from '@/context/ModalsContext';
import { devices } from '@/styles/breakpoints';

export const ConversionBanner = () => {
  const { setisModalQuoteOpen } = useModalContext();

  return (
    <Banner>
      <BannerText>
        <BannerHeadline>Ready to fix your HVAC problem today?</BannerHeadline>
        <BannerSub>Our San Diego experts are standing by.</BannerSub>
      </BannerText>
      <BannerButton onClick={() => setisModalQuoteOpen(true)}>
        Get a Free Quote
      </BannerButton>
    </Banner>
  );
};

const Banner = styled.div`
  background: #192d52;
  border-radius: 10px;
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 32px 0;

  @media only screen and ${devices.desktop} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

const BannerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const BannerHeadline = styled.h3`
  color: #ffffff;
  font-family: var(--font-roboto);
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  margin: 0;
`;

const BannerSub = styled.p`
  color: rgba(255, 255, 255, 0.85);
  font-family: var(--font-roboto);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
`;

const BannerButton = styled.button`
  background: #ffffff;
  color: #192d52;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-family: var(--font-roboto);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    background: #f0f4ff;
  }
`;
